import { getQueryParam } from '@/utils/queryParams';

export const PaymentStatusPage = () => {
  const autoCloseParam = getQueryParam('autoClose');
  const shouldAutoCloseWindow = autoCloseParam === 'true';
  if (shouldAutoCloseWindow) {
    window.close();
  }
  return null;
};
